import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SidebarStaff } from "./SidebarStaff";
import styles from "./StaffLayout.module.css";
export const StaffLayout = ({ children }) => {
    return (_jsxs("div", { className: styles.appContainer, children: [_jsx(SidebarStaff, {}), _jsx("main", { className: styles.mainContent, children: children })] }));
};
